import Fab from '@material-ui/core/Fab'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ForumIcon from '@material-ui/icons/ForumOutlined'
import { withStyles } from '@material-ui/styles'
import React, { Component } from 'react'
import { getEMPI, getMyneedsEOS, getMyneedsEOSnew } from '../ApiCall'
import CommonLoader from '../CommonLoader'
import CommonFooter from './CommonFooter'
import DataTable from './DataTable';
import DataTableNew from './DataTableNew'
import Header from './Header'
import './MyNeeds.css'
import { Tab, Tabs } from '@material-ui/core'
import customStyle from './programInfo/CSS/stylesheet_UHS.js'
import ContributionDataTable from './ContributionDataTable'
import ReimbursementDataTable from './ReimbursementDataTable'
const AntTabs = withStyles(customStyle.MyneedsTabs)(Tabs)

const CrudButton = withStyles(customStyle.crudBtn)(Fab)
export default class MyNeeds extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tableData: [],
      loader: true,
      notfoundmsg1: '',
      notfoundmsg2: '',
      notfoundmsg3: '', 
      open: false,
      tabEnable: localStorage.getItem("isAdmin") ? true: false,
      selectedTab:"MyShareRequests",
      showReimbursementFormInTab: false,
      selectedRowData: null
    }
  }

  componentDidMount() {
    this.getEMPID()
    let urlValues  = new URLSearchParams(window.location.search);
    let a =urlValues.get('open');
    if(a==true || a=="true")
    this.setState({open: true}, ()=>{
      this.props.history.push('/MyNeeds')
    })
    
    // Listen for reimbursement form completion event from iframe using postMessage
    window.addEventListener("message", this.handleReimbursementComplete)
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener("message", this.handleReimbursementComplete)
  }

  handleReimbursementComplete = (event) => {
    // Check if the message is from the reimbursement iframe
    if (event.data?.type === "memberReimbursementRequestComplete") {
      const eventData = event.data?.data || {}
      
      // Check if the event contains error information
      if (event.data?.error || event.data?.status === 'error') {
        console.error('Reimbursement request error:', eventData)
        // Handle error case - perform back button function
        this.goBack()
      } else {
        // Handle success case - perform back button function
        console.log('Reimbursement request completed successfully:', eventData)
        this.goBack()
      }
    }
  }

  getEMPID() {
    getEMPI().then(res => {
      this.myneedsEOS()
    })
    // this.setState({tableData: arrayNeeds, loader: false})
  }

  myneedsEOS = () => {
    getMyneedsEOS().then(res => {
      if (res.data && res.data.length > 0) {
        this.setState({ tableData: res.data, loader: false })
      } else {
        this.setState({
          notfoundmsg1: 'No needs have been entered into the system.',
          notfoundmsg2: 'Submitted needs may take 2-3 days to be displayed here.',
          notfoundmsg3: 'For any clarifications call Customer Service.',
          loader: false
        })
      }
    }).catch(err=>{
      this.setState({ loader: false })
    })
  }

  goBack = () => {
    if (this.state.showReimbursementFormInTab) {
      this.closeReimbursementForm()
    } else {
      this.props.history.push('/')
    }
  }

  getEncodedMemberData = () => {
    // Get member data from localStorage or state
    const memberData = {
      phone: localStorage.getItem('phone') || "",
      memberId: localStorage.getItem('EMPID') || "",
      email: localStorage.getItem('userMail') || "",
      initiatedUser: localStorage.getItem('userMail') || "",
      source: "MemberPortal",
      userRole: "USER",
      type: "Reimbursement",
      client: "UHF",
      memberName: localStorage.getItem('subscriberName') || "",
      requestId: this.state.selectedRowData?.id || ""
    }
    
    // Convert to JSON string and encode to base64
    const jsonString = JSON.stringify(memberData)
    const encodedData = btoa(jsonString)
    return encodedData
  }

  openReimbursementForm = (rowData = null) => {
    this.setState({ 
      selectedTab: "MyReimbursementRequests",
      showReimbursementFormInTab: true,
      selectedRowData: rowData
    })
  }

  closeReimbursementForm = () => {
    this.setState({ showReimbursementFormInTab: false })
  }

  getTabConfig = () => {
    const commonTabs = [
      { label: "MY NEEDS", value: "MyShareRequests" },
      { label: "MY REIMBURSEMENT REQUESTS", value: "MyReimbursementRequests" }
    ]
    
    const adminTabs = [
      { label: "MY NEEDS", value: "MyShareRequests" },
      { label: "MY CONTRIBUTIONS", value: "MyCONTRIBUTIONS" },
      { label: "MY REIMBURSEMENT REQUESTS", value: "MyReimbursementRequests" }
    ]
    
    return this.state.tabEnable ? adminTabs : commonTabs
  }

  renderTabs = () => {
    const tabs = this.getTabConfig()
    const tabStyle = {
      textTransform: 'capitalize',
      marginTop: 10,
      fontSize: 24
    }
    
    return (
      <AntTabs
        value={this.state.selectedTab}
        onChange={(e, newValue) => this.setState({selectedTab: newValue})}
        textColor="#33333"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        variant="fullWidth"
        id="tabs"
        style={{ width: '100%' }}
      >
        {tabs.map(tab => (
          <Tab 
            key={tab.value}
            label={tab.label} 
            value={tab.value} 
            style={{
              ...tabStyle,
              width: '13%',
              color: this.state.selectedTab === tab.value ? '#000' : '#7e7e7e'
            }} 
          />
        ))}
      </AntTabs>
    )
  }

  render() {
    return (
      <div className="progInfoMainWrapper">
        <Header name={'MyNeeds'} />
        {this.state.loader ? <CommonLoader /> : null}
        <div className="container progInfoContainer" style={{ zIndex: '0' }}>
          <sapn className="Back_page" onClick={this.goBack}>
            <ArrowBackIcon style={{ width: '24px', height: '24px', color: ' #2e3192', marginRight: '5px' }} onClick={this.goBack} />
            BACK
          </sapn>

          <div className="commonWrap_MyNeeds" style={{ marginTop: '15px' }}>
            {this.state.showReimbursementFormInTab ? (
              <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 250px)', backgroundColor: 'white' }}>
                <iframe
                  src={`${process.env.REACT_APP_PLUGIN}MemberReimbursementRequest/${this.getEncodedMemberData()}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                  title="Reimbursement Form"
                />
              </div>
            ) : (
              <>
                {!this.state.tabEnable && <div className="progInfoSection" style={{ marginBottom: '-20px' }}>
                  {this.renderTabs()}
                </div>}
                {this.state.tabEnable && this.renderTabs()}
                <div>
                  {this.state.selectedTab === "MyShareRequests" && 
                  <div className="tablebackgroundouter">
                    {this.state.tableData && this.state.tableData.length > 0 ? (
                        this.state.tabEnable?
                        <DataTableNew  open={this.state.open} tableData={this.state.tableData} />
                        :
                      <DataTable open={this.state.open} tableData={this.state.tableData} />
                    ) : (
                      <>
                        <div className="data_not_found">
                          <h5 class="noneeds_msg_display">{this.state.notfoundmsg1}</h5>
                          <h5 class="noneeds_msg_display">{this.state.notfoundmsg2}</h5>
                          <h5 class="noneeds_msg_display">{this.state.notfoundmsg3}</h5>
                        </div>
                      </>
                    )}
                  </div>}

                  {this.state.selectedTab === "MyReimbursementRequests" && 
                  <div className="tablebackgroundouter">
                    <ReimbursementDataTable onUpdateClick={(rowData) => this.openReimbursementForm(rowData)}/>
                  </div>}

                  {this.state.tabEnable && this.state.selectedTab === "MyCONTRIBUTIONS" && 
                  <div className="tablebackgroundouter">
                    <ContributionDataTable/>
                  </div>}

                  <div className="progInfoFooter">
                    <div className="row">
                      <div className="col-md-8 myNeedsFooterActionCol">
                        {!this.state.tabEnable && (
                          <button type="button" className="myNeedsReimbursementBtn" onClick={this.openReimbursementForm}>
                            REIMBURSEMENT
                            <br />
                            REQUEST
                          </button>
                        )}
                      </div>
                      <div className="col-md-4 dpFlex">
                        <div className="footerText" style={{ display: 'flex', flexDirection: 'row',whiteSpace:'nowrap' }}>
                          <div>
                            <p>Need help?</p>
                            <p>Chat with a Universal Health Fellowship Representative</p>
                            <p>{`or call ${localStorage.getItem('CONTACT_NUMBER')}`}
                          {/* {(() => {
                            var client_id_locale = localStorage.getItem('CLIENT_ID')
                            if (client_id_locale == '3211' || client_id_locale == '3098') {
                              return '(888) 366 6243'
                            } else {
                              return '(877)-987-1233'
                            }
                          })()} */}
                        </p>
                          </div>
                          <div style={{ marginLeft: 12 }}>
                            <CrudButton
                              className={'purechat-button-expand'}
                              color="primary"
                              onClick={() => window.pureChat()}
                              aria-label="add"
                              style={customStyle.CommonChatBtn}
                            >
                              <ForumIcon />
                            </CrudButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        

        
        <div style={{ paddingTop: "23vh" }}>
          <CommonFooter />
        </div>
      </div>
    )
  }

  openChat = () => {
    sessionStorage.setItem('chatwindow', true)
    this.props.history.push('/')
  }
}
const arrayNeeds =[
  {"member_id": "CNEO10421340", 
  "empi": "1015", 
  "bill_key": "20766", 
  "first_name": "Elaine", 
  "last_name": "Williams", 
  "date_paid": "2020-12-03", 
  "date_received": "2020-07-02", 
  "status": "Paid", 
  "charged_amount": 527.00, 
  "paid_amount": 451.37, 
  "paid_provider_name": "HealthWay Clinic.", 
  "start_of_service_date": "2020-03-10", 
  "end_date_of_service": "2020-03-10", 
  "nsa": 0.00, 
  "sharing_percentage": 0.0, 
  "consultation_fee": 25.0, 
  "ineligible_amount": 15.70, 
  "repricing_amount": 34.93, 
  "eligible_for_sharing": 451.37, 
  "member_responsibility": 40.70
},


]